import { RootState } from '@iwProvider/configureStore';

export const hasCreatedFlexiLoanApplicationInAccountPages = (
    state: RootState
) => state?.api?.customer_state?.data?.ui?.hasCreatedFlexiApplication;

export const getCompanyAnnualTurnover = (state: RootState) =>
    state?.api?.customer_state?.data?.application?.company
        ?.last_12_months_turnover?.amount;
